import { render, staticRenderFns } from "./VariantPrice.vue?vue&type=template&id=5c282c3c&"
import script from "./VariantPrice.vue?vue&type=script&lang=js&"
export * from "./VariantPrice.vue?vue&type=script&lang=js&"
import style0 from "./VariantPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports